module.exports = __webpack_public_path__ + "img/FK.62ec11a4.png";